export const SFS_HOME_SEARCH_TEST_EPPO_ID = 'web-2403-sfs-home-search-test';
export const SFS_HOME_SEARCH_TEST_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const NEW_CUSTOMER_COUPON_EPPO_ID = 'web-2425-new-customer-coupon';
export const NEW_CUSTOMER_COUPON_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const DESKTOP_SEARCH_BAR_EPPO_ID = 'web-2400-desktop-search-bar';
export const DESKTOP_SEARCH_BAR_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const LOGIN_MODAL_EPPO_ID = 'web-2162-login-modal';
export const LOGIN_MODAL_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const BOOKING_ENQUIRY_REBUILD_EPPO_ID = 'web-2479-booking-enquiry-rebuild';
export const BOOKING_ENQUIRY_REBUILD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};
